module.exports = __webpack_public_path__ + "static/media/06.5ddc44c0.png";